import React from 'react';
import { Button, IconButton, Paper, DialogTitle, DialogContent, Stack, TextField, Tooltip, Divider, Checkbox, FormControlLabel, Typography} from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog, UploadFiles } from '../include';
import _ from 'underscore';

class EditFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      company_id: this.props.row ? this.props.row.company_id : -1,
      uuid: this.props.row ? this.props.row.uuid : '',
      name: this.props.row ? this.props.row.name : '',
      path: this.props.row ? this.props.row.path : '',
      mime_type: this.props.row ? this.props.row.mime_type : '',
      hotstorage: this.props.row ? this.props.row.hotstorage : true,
      file_id: this.props.row ? this.props.row.id : -1,
      file_thumb: null,
    };
  }

  handleSubmit = () => {
    if (!this.props.edit) {
      this.props.api
        .post('/Files/', { company_id: this.state.company_id, uuid: this.state.uuid, name: this.state.name, path: this.state.path, mime_type: this.state.mime_type, hotstorage: this.state.hotstorage })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Arquivo criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/File/' + this.props.row.id, { company_id: this.state.company_id, id: this.state.file_id, uuid: this.state.uuid, name: this.state.name, path: this.state.path, mime_type: this.state.mime_type, hotstorage: this.state.hotstorage })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };

  handleDBRecord = (record, error) => {
    if(error)
      this.setState({company_id: -1, uuid: '', name: '', path: '', mime_type: '', hotstorage: true });
    else{
      this.setState({company_id: record.company_id, file_id: record.id, uuid: record.uuid, name: record.name, path: record.path, mime_type: record.mimetype, hotstorage: record.hotstorage });
      this.getFileFromFileServer(record.id);
    }
  }
  
  componentDidMount() {
    if(this.state.file_id > 0)
      this.getFileFromFileServer(this.state.file_id);
  }
  
  getFileFromFileServer = (id) => {
    this.props.api
      .get('/FileServer/file/' + id, {responseType: 'blob'})
      .then((r) => {
        if( r.type !== "application/json" ){  
          const url = URL.createObjectURL(r);
        
          // in case you don't need the blob anymore, blob can be garbage collected
          //img.onload = e => URL.revokeObjectURL(url);
        
          this.setState({file_thumb: url});
        }
        else{
          try{  
          const outurl = URL.createObjectURL(r);
          fetch(outurl).then(res => {
            res.text().then(txt => {
              var dic = JSON.parse(txt);
              var msg = dic.error
              if(dic.coldstorage)
                msg = msg + ". Arquivo dispónível somente no coldstorage."
              this.props.alert(msg);
            });  
          });
          }catch(err){
            console.log(err);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });      
  }
  
  
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Arquivo' : 'Adicionar Arquivo'}
        </DialogTitle>
        <DialogContent>
          {this.state.file_thumb && <iframe title="fileFrame" src={this.state.file_thumb} frameBorder="0" scrolling="yes" width='100%' />}
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={15}
            acceptableFileTypes={".jpg, .png, .jpeg, .pdf, .mp4"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error) }}
            registerIntoDB={false}
            caption=""
          />
          { (this.state.file_id > 0) && <><D h="1rem" /><Typography>File ID: {this.state.file_id} </Typography></>}
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="ID da Empresa"
            value={this.state.company_id}
            onChange={(e) => this.setState({ company_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="UUID"
            value={this.state.uuid}
            onChange={(e) => this.setState({ uuid: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Nome"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Path"
            value={this.state.path}
            onChange={(e) => this.setState({ path: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="MIME Type"
            value={this.state.mime_type}
            onChange={(e) => this.setState({ mime_type: e.target.value })}
            required
          />
          <D h="1rem" />
          <FormControlLabel control={
            <Checkbox 
              checked={this.state.hotstorage} 
              onChange={(e) => this.setState({ hotstorage: e.target.checked })} 
            />
          } label="Pertence ao Hotstorage" />
          <D h="2rem" />
          <Stack direction="row" justifyContent="flex-end" spacing={1} >
            <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
              Cancelar
            </Button>
            <Button variant="outlined" color="primary" onClick={this.handleSubmit}>
              Salvar
            </Button>
          </Stack>
        </DialogContent>
      </form>
    );
  }
}

export class File extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'company_id', headerName: 'Empresa', width: 70 },
      { field: 'uuid', headerName: 'UUID', width: 280 },
      { field: 'name', headerName: 'Nome', width: 250 },
      { field: 'path', headerName: 'Path', width: 250 },
      { field: 'mime_type', headerName: 'MIME Type', width: 90 },
      { field: 'hotstorage', headerName: 'Hotstorage', width: 90 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Files', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        this.setState({
          dataTable: r.files || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditFile
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/File/" + row.id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditFile
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
